import { gql } from "graphql-request";

export const getAllNotifications = gql`
query {
    allNotifications {
      success
      message
      data {
        id
        message
        notificationType
        isRead
        createdAt
        task {
          id
          title
        }
        user {
          id
          username
        }
      }
    }
}
`;

export const getNotificationById = `
query GetNotificationById($id: Int!) {
  getNotificationById(id: $id) {
    success
    message
    data {
      id
      message
      task{
        title
      }
      notificationType
      isRead
      createdAt
    }
  }
}`;

export const updateNotification = gql`
mutation updatenotification($input:UpdateNotificationInput!){
  updateNotification(input:$input){
    success
    message
    error
  }
}`;

export const filterNotificationType = gql`
query AllNotifications($userId: Int!, $notificationType: String!) {
  allNotifications(userId: $userId, notificationType: $notificationType) {
    success
    message
    data {
      id
      message
      isRead
      notificationType
      createdAt
    }
  }
}
 `